import type { ReactNode } from "react";
import { tv } from "tailwind-variants";

export const layout = tv({
  base: "max-w-screen-lg py-5 px-5 md:px-10",
});

interface LayoutProps {
  className?: string;
  children: ReactNode;
}

/**
 * Applies app-level padding on all breakpoints
 */
export function Layout({ className, children }: LayoutProps): JSX.Element {
  return <div className={layout({ className })}>{children}</div>;
}
